module.exports = __webpack_public_path__ + "d00779d3c6a4b8666190873043676a44.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/subscription-icons/WorMa-Icon-White.png
// module id = 2124
// module chunks = 1